import React from "react";
import { Trans, useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { MantineAccordion } from "components/bootstrap";
const StyledPre = styled.pre(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.small};
  `
);
const DnsAdapterDocumentation = () => {
  const { t } = useTranslation("lookup_tables");
  const styleMarginBottom = { marginBottom: 10 };
  const aResponse = `{
  "single_value": "34.239.63.98",
  "multi_value": {
    "results": [
      {
        "ip_address": "34.239.63.98",
        "dns_ttl": 60
      },
      {
        "ip_address": "34.238.48.57",
        "dns_ttl": 60
      }
    ]
  },
  "ttl": 60000
}`;
  const aaaaResponse = `{
  "single_value": "2307:f8b0:3000:800:0:0:0:200e",
  "multi_value": {
    "results": [
      {
        "ip_address": "2307:f8b0:3000:800:0:0:0:200e",
        "dns_ttl": 77
      }
    ]
  },
  "ttl": 77000
}`;
  const aAndAaaaResponse = `{
  "single_value": "144.222.6.132",
  "multi_value": {
    "results": [
      {
        "ip_address": "144.222.6.132",
        "dns_ttl": 32,
        "ip_version": "IPv4"
      },
      {
        "ip_address": "1207:f8b1:6003:b01:0:0:0:8a",
        "dns_ttl": 299,
        "ip_version": "IPv6"
      }
    ]
  },
  "ttl": 32000
}`;
  const ptrResponse = `{
  "single_value": "c-45-216-65-41.hd1.fl.someisp.co.uk",
  "multi_value": {
    "domain": "someisp.co.uk",
    "full_domain": "c-45-216-65-41.hd1.fl.someisp.co.uk",
    "dns_ttl": "300",
  },
  "ttl": 300000
}`;
  const txtResponse = `{
  "single_value": null,
  "multi_value": {
    "results": [
      {
        "value": "Some text value that lives in a TXT DNS",
        "dns_ttl": 300
      },
      {
        "value": "v=spf1 include:some-email-domain.org ~all.",
        "dns_ttl": 200
      }
    ]
  },
  "ttl": 200000
}`;
  const accordionItems = [
    {
      value: "ipv4",
      label: t("dns_adapter.lookup_type_a"),
      content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "dns_doc.a", components: { code: /* @__PURE__ */ React.createElement("code", null) } })), /* @__PURE__ */ React.createElement(StyledPre, null, aResponse))
    },
    {
      value: "ipv6",
      label: t("dns_adapter.lookup_type_aaaa"),
      content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "dns_doc.aaaa", components: { code: /* @__PURE__ */ React.createElement("code", null) } })), /* @__PURE__ */ React.createElement(StyledPre, null, aaaaResponse))
    },
    {
      value: "ipv4&ipv6",
      label: t("dns_adapter.lookup_type_a_aaaa_singular"),
      content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "dns_doc.a_aaaa", components: { code: /* @__PURE__ */ React.createElement("code", null) } })), /* @__PURE__ */ React.createElement(StyledPre, null, aAndAaaaResponse))
    },
    {
      value: "ptr",
      label: t("dns_adapter.lookup_type_ptr"),
      content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "dns_doc.ptr", components: { code: /* @__PURE__ */ React.createElement("code", null) } })), /* @__PURE__ */ React.createElement(StyledPre, null, ptrResponse))
    },
    {
      value: "txt",
      label: t("dns_adapter.lookup_type_txt"),
      content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "dns_doc.txt", components: { code: /* @__PURE__ */ React.createElement("code", null) } })), /* @__PURE__ */ React.createElement(StyledPre, null, txtResponse))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h3", { style: styleMarginBottom }, t("shared.configuration")), /* @__PURE__ */ React.createElement("h5", { style: styleMarginBottom }, t("dns_adapter.lookup_type_label")), /* @__PURE__ */ React.createElement(MantineAccordion, { accordionItems, defaultValue: "ipv4" }), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("h5", { style: styleMarginBottom }, t("dns_doc.server_ips_title")), /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "dns_doc.server_ips", components: { code: /* @__PURE__ */ React.createElement("code", null) } })), /* @__PURE__ */ React.createElement("h5", { style: styleMarginBottom }, t("dns_adapter.request_timeout_label")), /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, t("dns_doc.request_timeout")), /* @__PURE__ */ React.createElement("h5", { style: styleMarginBottom }, t("dns_adapter.cache_ttl_override")), /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, t("dns_doc.cache_ttl_override")));
};
export default DnsAdapterDocumentation;
